import React from 'react';
import { DataTable } from '@/components/ui';
import type { DataTableColumn } from '@/components/ui';
import type { Vehicle, VehicleAttachment } from '../../../types/Vehicle';
import { formatWhen, vehicleTransferService } from '../../../services/vehicleTransferService';

function sizeText(bytes?: number | null): string {
  if (!bytes) return '';
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/** Files on the unit. Today they all come from service-area transfers: the signed record, photos and documents. */
const EquipmentAttachmentsTab: React.FC<{ vehicle: Vehicle }> = ({ vehicle }) => {
  const files = (vehicle.vehicleAttachments ?? [])
    .filter((a) => a.vehicleTransferId)
    .sort((a, b) => String(b.createdAt).localeCompare(String(a.createdAt)));

  const columns: DataTableColumn<VehicleAttachment>[] = [
    {
      key: 'name',
      header: 'File',
      mobile: 'title',
      cell: (a) => (
        <a
          href={vehicleTransferService.fileUrl(a.vehicleTransferId!, a.id)}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          className="tw-inline-flex tw-items-center tw-gap-1"
        >
          <i className={`bi ${a.mimeType === 'application/pdf' ? 'bi-file-earmark-pdf' : 'bi-image'}`} aria-hidden="true" />
          {a.name || a.fileName}
        </a>
      ),
    },
    { key: 'description', header: 'About', mobile: 'subtitle', cell: (a) => a.description },
    { key: 'size', header: 'Size', mobileLabel: 'Size', className: 'tw-whitespace-nowrap tw-tabular-nums', cell: (a) => sizeText(a.sizeBytes) },
    { key: 'added', header: 'Added', mobileLabel: 'Added', className: 'tw-whitespace-nowrap', cell: (a) => formatWhen(a.createdAt) },
  ];

  return (
    <DataTable
      columns={columns}
      data={files}
      rowKey={(a) => a.id}
      emptyMessage="No files yet. A completed service-area transfer attaches its signed record here."
    />
  );
};

export default EquipmentAttachmentsTab;
